module.exports = __webpack_public_path__ + "static/media/unicad-bg.d817d2ab.png";